import { createModel, createSaga, createReducer } from '@/store/tools';
import { put, takeEvery } from 'redux-saga/effects';
import http from '@/assets/api/http';

const dataList = { dataList: [], pageNum: 1, pageSize: 20, resultTotal: 0 };
const model = {
    namespace: 'riskcontrol',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getRiskcontrol': T('getRiskcontrol'),
        },
        actions: {
            'getRiskcontrol': A('getRiskcontrol'), // 风控管理初始数据
        },
        sagas: {
            'getRiskcontrol': S('getRiskcontrol', '/?cmd=com.xqxc.api.pig.mis.biz.platform.AdminParamMisService.listAdminParamByParamType', 'POST'),
        },
        reducers: {
            'riskcontrol': R('getRiskcontrol', []),
        }
    })
};
export default createModel(model);